import { Injectable, inject } from '@angular/core';
import { AuthService } from './auth.service';
import { MsgService } from './msg.service';

@Injectable({
    providedIn: 'root',
})
export class LogoutService {
    private _authService = inject(AuthService);
    private _msgService = inject(MsgService);

    confirmLogout(onCancel?: () => void): void {
        this._msgService.showConfirm(
            'shared.general.dialogs.logout.title',
            'shared.general.dialogs.logout.message',
            'shared.general.dialogs.logout.subtext',
            '',
            'error'
        ).afterClosed().subscribe((result) => {
            if (result) {
                this._authService.logout();
            } else {
                onCancel?.();
            }
        });
    }
}
